import React, {Component} from 'react'
import Footer from "../../shared/Footer";
import Dropzone from "react-dropzone";
import {Button} from "react-bootstrap";
import BOKService from "../../konto/panel/panelComponents/bokComponents/BOKService";
import Zgody from "../../shared/Zgody";
import {NotificationManager} from "react-notifications";
import Select from "react-select";
import {Link} from "react-router-dom";

export default class Kontakt extends Component {

    constructor(props) {
        super(props);

        let wybranyTemat = ''

        if (window.location.href.indexOf('zwrot') > -1) {
            wybranyTemat = {value: 'Zwrot biletu nr:', label: 'Zwrot biletu'}
        }

        this.state = {
            warunki: false,
            email: '',
            imie: '',
            nazwisko: '',
            temat: '',
            tematy: [
                {value: 'Faktury / ceny', label: 'Faktury / ceny'},
                {value: 'Informacje', label: 'Informacje'},
                {value: 'Zwrot biletu nr:', label: 'Zwrot biletu'},
                {value: 'Inne', label: 'Inne'},
            ],
            tresc: '',
            nrRez: '',
            wybranyTemat: wybranyTemat,
            loader: false,
            plik: [],
            plikBase: '',
            plikInvalid: false,
            tematInvalid: false,
            trescInvalid: false,
            imieInvalid: false,
            nazwiskoInvalid: false,
            mailInvalid: false,
            nrRezInvalid: false
        };
        this.handleEmail = this.handleEmail.bind(this);
        this.handleImie = this.handleImie.bind(this);
        this.handleNazwisko = this.handleNazwisko.bind(this);
        this.handleTresc = this.handleTresc.bind(this);
        this.handleNrRez = this.handleNrRez.bind(this);
        this.handleTemat = this.handleTemat.bind(this)
        this.handleWybranyTemat = this.handleWybranyTemat.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleEmail(e) {
        this.setState({email: e.target.value})
    }

    handleImie(e) {
        this.setState({imie: e.target.value})
    }

    handleNazwisko(e) {
        this.setState({nazwisko: e.target.value})
    }

    handleTresc(e) {
        this.setState({tresc: e.target.value})
    }

    handleNrRez(e) {
        if (e.target.value.length <= 18) {
            this.setState({nrRez: e.target.value})
        }
    }

    handleTemat(e) {
        this.setState({temat: e.target.value})
    }

    handleWybranyTemat(e) {
        let temat = e.value
        if (e.value === 'Inne') {
            temat = ''
        }
        this.setState({wybranyTemat: e, temat: temat})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plikInvalid: true, plik: []})
        } else {
            this.getBase64(accepted);
            this.setState({plikInvalid: false, plik: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({plikBase: reader.result.substr(reader.result.indexOf(',') + 1)})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    postZgloszenie() {
        let name = '';
        let type = '';
        let size = 0;
        let plik = null;
        let temat = this.state.wybranyTemat.value
        if (this.state.plik[0] !== null && this.state.plik[0] !== undefined) {
            plik = this.state.plikBase;
            name = this.state.plik[0].name;
            size = this.state.plik[0].size;
            type = this.state.plik[0].type
        }
        if (this.state.wybranyTemat.label === 'Zwrot biletu') {
            temat = this.state.wybranyTemat.value + ' ' + this.state.nrRez
        }
        if (this.state.wybranyTemat.label === 'Inne') {
            temat = 'Inne: ' + this.state.temat
        }
        BOKService.postZgloszenieNieZal(this.state.email, this.state.imie,
            this.state.nazwisko, this.state.nrRez, plik, name, size, type,
            temat, this.state.tresc, 1)
            .then(function (response) {
                this.setState({
                    email: '',
                    imie: '',
                    nazwisko: '',
                    temat: '',
                    tresc: '',
                    nrRez: '',
                    plik: [],
                    plikBase: '',
                    plikInvalid: false,
                    imieInvalid: false,
                    nazwiskoInvalid: false,
                    tematInvalid: false,
                    trescInvalid: false,
                    nrRezInvalid: false,
                    mailInvalid: false,
                    loader: false
                });
                NotificationManager.success("", "Twoje zgłoszenie zostało wysłane.", 5000);
            }.bind(this))
    }

    wyslijZgloszenie() {

        console.log(this.state)

        this.setState({loader: true}, () => {
            let temat, tresc, mail, imie, nazwisko, nrRez;

            if (this.state.wybranyTemat.label === 'Zwrot biletu') {
                if (this.state.nrRez.length === 0 || isNaN(this.state.nrRez)) {
                    nrRez = true
                }
            }

            if (this.state.tresc.length <= 0) {
                tresc = true
            }
            if (this.state.email.length === 0) {
                mail = true
            }
            if (this.state.imie.length === 0) {
                imie = true
            }
            if (this.state.nazwisko.length === 0) {
                nazwisko = true
            }
            if (this.state.nrRez.length !== 0 && isNaN(this.state.nrRez)) {
                nrRez = true
            }
            if (!temat && !tresc && !imie && !nazwisko && !mail && !nrRez) {
                if (this.state.warunki) {
                    this.postZgloszenie()
                } else {
                    NotificationManager.error("", "Aby wysłać zgłoszenie należy zaakceptować warunki ", 5000);
                    this.setState({
                        tematInvalid: temat,
                        trescInvalid: tresc,
                        mailInvalid: mail,
                        imieInvalid: imie,
                        nazwiskoInvalid: nazwisko,
                        nrRezInvalid: nrRez,
                        loader: false
                    })
                }
            } else {
                this.setState({
                    tematInvalid: temat,
                    trescInvalid: tresc,
                    mailInvalid: mail,
                    imieInvalid: imie,
                    nazwiskoInvalid: nazwisko,
                    nrRezInvalid: nrRez,
                    loader: false
                })
            }
        })
    }

    render() {
        return <div>

            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Skontaktuj się z nami przez nasz formularz.</b></h2>
                    <h4>Nasi konsultanci pomogą znaleźć rozwiązanie.</h4>
                </div>
            </div>
            <div style={{background: '#efefef', paddingTop: '25px', paddingBottom: '25px'}}
                 className="paddingContainerMobilka">
                <div className="container ramka" style={{background: '#fff', padding: 50}}>
                    <div className="text-center"><h2 style={{fontWeight: 'bold'}}>Formularz kontaktowy</h2></div>
                    <div>
                        <div>
                            <b>Temat: <font style={{color: 'red'}}>*</font></b>
                            <Select
                                onChange={this.handleWybranyTemat}
                                options={this.state.tematy}
                                value={this.state.wybranyTemat}
                                placeholder="Wybierz temat"
                                matchPos="start"
                                style={{height: 38, marginTop: 10, marginBottom: 10, borderColor: '#e0e0e0'}}
                                clearable={false}
                            />
                            {this.state.wybranyTemat.value === 'Inne' ?
                                <div>
                                    <b>Treść tematu: </b>
                                    <input type="text" value={this.state.temat} onChange={this.handleTemat}
                                           maxLength={40}
                                           style={{
                                               marginTop: 10,
                                               width: '100%',
                                               border: '1px solid #e0e0e0',
                                               borderRadius: 5,
                                               padding: 10,
                                               marginBottom: 10
                                           }}
                                           placeholder={"Wpisz temat..."}/>
                                </div> : null}
                            {this.state.wybranyTemat.label === 'Zwrot biletu' ?
                                <div>
                                    <b>Nr biletu: </b>
                                    <input type="number" value={this.state.nrRez} onChange={this.handleNrRez}
                                           onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === ',') && evt.preventDefault()}
                                           style={{
                                               marginTop: 10,
                                               width: '100%',
                                               border: '1px solid #e0e0e0',
                                               borderRadius: 5,
                                               padding: 10,
                                               marginBottom: 10
                                           }}
                                           placeholder={"Wpisz numer biletu..."}/>
                                    {this.state.nrRezInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy
                                            podać
                                            poprawny numer biletu.</div> : null}
                                </div> : null}
                            {this.state.tematInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy
                                    podać
                                    temat.</div> : null}
                        </div>
                        <div>
                            <b>E-mail: <font style={{color: 'red'}}>*</font></b>
                            <input type="text" value={this.state.email} onChange={this.handleEmail} maxLength={100}
                                   style={{
                                       marginTop: 10,
                                       width: '100%',
                                       border: '1px solid #e0e0e0',
                                       borderRadius: 5,
                                       padding: 10,
                                       marginBottom: 10
                                   }}
                                   placeholder={"Wpisz adres e-mail..."}/>
                            {this.state.mailInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                    adres e-mail.</div> : null}
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <b>Imię: <font style={{color: 'red'}}>*</font></b>
                                <input type="text" value={this.state.imie} onChange={this.handleImie}
                                       maxLength={100} style={{
                                    marginTop: 10,
                                    width: '100%',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 5,
                                    padding: 10,
                                    marginBottom: 10
                                }}
                                       placeholder={"Wpisz imię..."}/>
                                {this.state.imieInvalid ?
                                    <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                        imię.</div> : null}
                            </div>
                            <div className="col-sm-6">
                                <b>Nazwisko: <font style={{color: 'red'}}>*</font></b>
                                <input type="text" value={this.state.nazwisko} onChange={this.handleNazwisko}
                                       maxLength={100}
                                       style={{
                                           marginTop: 10,
                                           width: '100%',
                                           border: '1px solid #e0e0e0',
                                           borderRadius: 5,
                                           padding: 10,
                                           marginBottom: 10
                                       }}
                                       placeholder={"Wpisz nazwisko..."}/>
                                {this.state.nazwiskoInvalid ?
                                    <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                        nazwisko.</div> : null}
                            </div>
                            {/*<div className="col-sm-6">*/}
                            {/*    <b>Numer biletu: </b>*/}
                            {/*    <input type="text" value={this.state.nrRez} onChange={this.handleNrRez} maxLength={100}*/}
                            {/*           style={{*/}
                            {/*               marginTop: 10,*/}
                            {/*               width: '100%',*/}
                            {/*               border: '1px solid #e0e0e0',*/}
                            {/*               borderRadius: 5,*/}
                            {/*               padding: 10,*/}
                            {/*               marginBottom: 10*/}
                            {/*           }}*/}
                            {/*           placeholder={"Wpisz numer biletu..."}/>*/}
                            {/*    {this.state.nrRezInvalid ?*/}
                            {/*        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać*/}
                            {/*            poprawny numer biletu.</div> : null}*/}
                            {/*</div>*/}
                        </div>
                        <div>
                            <b>Treść zgłoszenia: <font style={{color: 'red'}}>*</font></b>
                            <textarea rows={10} value={this.state.tresc} maxLength={1000} onChange={this.handleTresc}
                                      style={{
                                          marginTop: 10,
                                          width: '100%',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: 5,
                                          padding: 10
                                      }}
                                      placeholder={"Wpisz wiadomość..."}/>
                            {this.state.trescInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                    treść.</div> : null}
                        </div>
                        <div className="row" style={{marginTop: 5}}>
                            <div className="col-sm-12">
                                <b>Plik: </b>
                                <Dropzone maxSize={10000000}
                                          style={{
                                              maxWidth: '100%',
                                              height: 150,
                                              border: '1px dashed #ced4da',
                                              borderRadius: '0.25rem',
                                              paddingTop: 15,
                                              marginTop: 10,
                                              marginBottom: 10,
                                              textAlign: 'center',
                                              fontSize: '0.875rem',
                                              color: '#565756',
                                              cursor: 'pointer'
                                          }}
                                          onDrop={(accepted, rejected) => {
                                              this.onDrop(accepted, rejected)
                                          }}>
                                    {this.state.plik.length === 0 ? <div>
                                        <div style={{paddingTop: '5%'}}>Maksymalny rozmiar pliku: 10mb</div>
                                    </div> : <div>
                                        <div style={{paddingTop: '4%'}}><b>{this.state.plik[0].name}</b></div>
                                        <p>(Kliknij by zmienić plik)</p>
                                    </div>}
                                </Dropzone>
                                {this.state.zdjecieInvalid ?
                                    <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawny
                                        plik
                                        zdjecia.</div> : null}
                            </div>
                        </div>
                        <Zgody war2={true} warunki={this.state.warunki}
                               setWarunki={() => this.setState({warunki: !this.state.warunki})}/>
                        <div className="text-right">
                            <Button bsStyle={'success'} disabled={this.state.loader} onClick={() => {
                                this.wyslijZgloszenie()
                            }}>Wyślij zgłoszenie</Button>
                            {this.state.loader ? <div className="loaderDim" style={{marginTop: 5}}><i
                                className="fa fa-spinner fa-pulse fa-fw"
                                style={{
                                    color: '#58b13d'
                                }}> </i></div> : null}
                        </div>
                    </div>
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Footer/>
        </div>
    }


}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Kontakt.js